import * as defaultFns from "./demoBrand";

// export function getExchange(props) {
//     return defaultFns.getExchange(props);
// }

export function getProducts(props) {
    const products = defaultFns.getProducts(props);
    products.refundOptions = null;
    return products;
}
